import { render, staticRenderFns } from "./printPurchases.vue?vue&type=template&id=7f507401&scoped=true&"
import script from "./printPurchases.vue?vue&type=script&lang=js&"
export * from "./printPurchases.vue?vue&type=script&lang=js&"
import style0 from "./printPurchases.vue?vue&type=style&index=0&id=7f507401&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f507401",
  null
  
)

component.options.__file = "printPurchases.vue"
export default component.exports